import { render } from "./TresholdSlider.vue?vue&type=template&id=bdcf346e"
import script from "./TresholdSlider.vue?vue&type=script&lang=js"
export * from "./TresholdSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__